<template>
  <div v-if="items"
       class="nav-item"
       @click.stop="openSettings">
    <p style="margin-right: 6px" class="nav-name">Настройки</p>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6.5L8 10.5L12 6.5" stroke="#566A83" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

    <div class="settings-dropdown" v-if="showSettingsDropdown">
      <router-link v-for="item in items"
                   :to="item.url"
                   class="settings-dropdown-item">{{item.name}}</router-link>

    </div>
  </div>
</template>
<script setup>
import {onMounted, onUnmounted, ref} from "vue";

const props = defineProps({
  items: [Array, Object],
})

const showSettingsDropdown = ref(false)
const openSettings = () => {
  showSettingsDropdown.value = !showSettingsDropdown.value
}

const onOuterSettingsClick = function (e) {
  if (!e.target.closest(".header-main__settings-dropdown") && showSettingsDropdown.value) {
    showSettingsDropdown.value = false;
  }
};
onMounted(() => {
  document.addEventListener("click", onOuterSettingsClick);
});

onUnmounted(() => {
  document.removeEventListener("click", onOuterSettingsClick);
});
</script>

<style scoped lang="scss">
.nav-item {
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}

.nav-name {
  margin-left: 8px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
  opacity: 0.5;
}

.settings-dropdown {
  padding: 8px;
  width: 205px;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  top: 40px;
  border: 1px solid rgba(228, 231, 238, 1);
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05);
}

.settings-dropdown-item {
  padding: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.94px;
  letter-spacing: 0%;
  color: $dark-blue;
  text-decoration: none;
  height: 40px;
}
</style>